import { useEffect, useState } from "react";
import { IOrderDetailByName } from "../models/IOrderDetail";
import { getOrderDetailsByOrderName } from "../services/orderService";
import { OrderDetailView, orderErrorMessage } from "./OrderQueryTool";

export function OrderDetailModal({
  orderNo,
  onClose,
}: {
  orderNo: string;
  onClose: () => void;
}) {
  const [detail, setDetail] = useState<IOrderDetailByName | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isNarrow, setIsNarrow] = useState(window.innerWidth < 640);

  useEffect(() => {
    const onResize = () => setIsNarrow(window.innerWidth < 640);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const load = () => {
    setLoading(true);
    setError(null);
    setDetail(null);
    getOrderDetailsByOrderName(orderNo.replace(/^#+/, ""))
      .then((res) => setDetail(res.data))
      .catch((err) => setError(orderErrorMessage(err)))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderNo]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: "fixed", inset: 0, zIndex: 2040,
          background: "rgba(0,0,0,0.5)",
          backdropFilter: "blur(4px)",
        }}
      />

      {/* Modal — küçük ekranda tam ekran */}
      <div
        style={isNarrow ? {
          position: "fixed", inset: 0, zIndex: 2050, background: "#fff",
          display: "flex", flexDirection: "column", overflow: "hidden",
        } : {
          position: "fixed", top: "50%", left: "50%", zIndex: 2050,
          transform: "translate(-50%, -50%)",
          width: "min(680px, calc(100vw - 24px))",
          maxHeight: "88dvh",
          background: "#fff",
          borderRadius: 20,
          boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
          display: "flex", flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div style={{
          padding: "16px 20px",
          background: "linear-gradient(135deg, #1e1b4b, #312e81)",
          display: "flex", alignItems: "center", gap: 12,
          flexShrink: 0,
        }}>
          <div style={{
            width: 40, height: 40, borderRadius: 12, flexShrink: 0,
            background: "rgba(255,255,255,0.15)",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <i className="bi bi-receipt text-white" style={{ fontSize: "1.2rem" }} />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 800, fontSize: "1rem", color: "#fff" }}>Sipariş Detayı</div>
            <div style={{ fontSize: "0.72rem", color: "rgba(255,255,255,0.7)", fontWeight: 600 }}>
              Müşteriye yardımcı olmak için siparişin tüm bilgileri
            </div>
          </div>
          <button
            onClick={load}
            disabled={loading}
            title="Yenile"
            style={{
              background: "rgba(255,255,255,0.15)", border: "none",
              borderRadius: 9, width: 34, height: 34, flexShrink: 0,
              display: "flex", alignItems: "center", justifyContent: "center",
              cursor: loading ? "default" : "pointer", color: "#fff", fontSize: "0.9rem",
            }}
          >
            <i className="bi bi-arrow-clockwise" />
          </button>
          <button
            onClick={onClose}
            title="Kapat"
            style={{
              background: "rgba(255,255,255,0.15)", border: "none",
              borderRadius: 9, width: 34, height: 34, flexShrink: 0,
              display: "flex", alignItems: "center", justifyContent: "center",
              cursor: "pointer", color: "#fff", fontSize: "0.9rem",
            }}
          >
            <i className="bi bi-x-lg" />
          </button>
        </div>

        {/* Body */}
        <div style={{ flex: 1, overflowY: "auto", padding: isNarrow ? 14 : 20 }}>
          {loading && (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "48px 0" }}>
              <span className="spinner-border" style={{ color: "#4f46e5" }} role="status" />
            </div>
          )}

          {error && (
            <div style={{
              padding: "14px 16px", borderRadius: 12,
              background: "#fef2f2", border: "1.5px solid #fecaca",
              color: "#991b1b", fontSize: "0.85rem",
              display: "flex", alignItems: "center", gap: 8,
            }}>
              <i className="bi bi-exclamation-circle-fill" />
              {error}
            </div>
          )}

          {detail && <OrderDetailView order={detail} orderCode={orderNo} />}
        </div>

        {/* Footer */}
        <div style={{ padding: "12px 20px", borderTop: "1.5px solid #f1f5f9", display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
          <button
            onClick={onClose}
            style={{
              background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 10,
              padding: "8px 18px", fontWeight: 700, fontSize: "0.85rem", color: "#374151", cursor: "pointer",
            }}
          >
            <i className="bi bi-x-lg me-1" />Kapat
          </button>
        </div>
      </div>
    </>
  );
}
